import React, { Component } from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import Schedule from '@material-ui/icons/Schedule';

const styles = (theme) => ({
  sectionContainer: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  titleText: {
    fontWeight: 'bold',
    lineHeight: 1.2,
    [theme.breakpoints.down('sm')]: { lineHeight: 1 },
  },
  subtitle: {
    lineHeight: 1.2,
    [theme.breakpoints.down('sm')]: { lineHeight: 1 },
  },
  // time: {
  //   fontSize: '0.7rem',
  //   lineHeight: 0.43,
  //   fontWeight: 'bold',
  //   color: '#0d4d96',
  //   [theme.breakpoints.down('sm')]: {},
  // },
});

class SectionHeader extends Component {
  render() {
    const { classes, title, subtitle, time } = this.props;
    return (
      <div className={classes.sectionContainer}>
        <Grid container item xs={12}>
          <Typography className={classes.titleText}>
            {/* **KSC2022 cutom : 룸별 이름 표시 요청 있을 수 있음, 해당 형태로 유지 */}
            {title && title === 'Channel01' && 'Channel 1'}
            {title && title === 'Channel02' && 'Channel 2'}
            {title && title === 'Channel03' && 'Channel 3'}
            {title && title === 'Channel04' && 'Channel 4'}
            {title && title === 'Channel05' && 'Channel 5'}
            {title && title === 'Channel06' && 'Channel 6'}

            {/* {title} */}
          </Typography>
        </Grid>
        <Grid container item xs={12} alignItems="center">
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        </Grid>
        <Grid container item xs={12} alignItems="center">
          <Schedule style={{ color: '#0d4d96' }} />
          <Typography style={{ fontSize: 'small', marginLeft: '5px' }}>{time}</Typography>
        </Grid>
        {/* <div className={classes.time}>
          <Schedule style={{ fontSize: '0.8rem' }} /> <div style={{ marginTop: '-8px', marginLeft: '15px' }}>{time}</div>
        </div> */}
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(SectionHeader));
